import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';
import { generateCodeChallenge, generateCodeVerifier } from 'src/utils/pkce';

async function redirectToIdPorten() {
  const authorizeEndpoint = process.env.REACT_APP_IDPORTEN_AUTHORIZE_ENDPOINT;
  const clientId = process.env.REACT_APP_IDPORTEN_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_IDPORTEN_REDIRECT_URI;
  const scope = 'openid profile';
  const state = uuidv4();
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  sessionStorage.setItem('idPortenLoginState', state);
  sessionStorage.setItem('idPortenCodeVerifier', codeVerifier);

  window.location.href = `${authorizeEndpoint}?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
}

export default function IdPortenLoginButton() {
  const { search } = useLocation();

  if (!process.env.REACT_APP_IDPORTEN_CLIENT_ID) return null;

  const verificationGuid = new URLSearchParams(search).get('verificationGuid') ?? null;
  if (verificationGuid) sessionStorage.setItem('verificationGuid', verificationGuid);

  return (
    <button
      onClick={redirectToIdPorten}
      className="w-full flex justify-center p-4 mt-4 text-white rounded-full"
      style={{ backgroundColor: '#00263D' }}
    >
      Fortsett med ID-porten
    </button>
  );
}
